<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" fab text>
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar color="grey" class="mr-3">
                <span class="white--text" v-if="currentUser">{{shortName}}</span>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-if="currentUser">{{currentUser.name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item @click="logout">
            <v-list-item-content>
              <v-list-item-title>Se déconnecter</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["keycloak", "currentUser"],
  methods: {
    logout: function() {
      localStorage.clear();
      this.keycloak.logout();
    }
  },
  computed: {
    shortName: function() {
      return `${this.currentUser.given_name.substr(
        0,
        1
      )}${this.currentUser.family_name.substr(0, 1)}`;
    }
  },
  data: () => ({
    menu: false
  })
};
</script>